import { SET_LIST_STAFF } from "../../assets/constants/reducer.type";

const initialState = {
  list: null,
};

const staffReducer = (
  state = initialState,
  actions = {
    type: "",
    payload: null,
  }
) => {
  const { type, payload } = actions;

  switch (type) {
    case SET_LIST_STAFF:
      return { ...state, list: payload };
    default:
      return state;
  }
};

export default staffReducer;
